<template>
  <div class="">
    <md-card class="md-layout-item">
      <md-card-header>
        <div class="md-title">Local</div>
      </md-card-header>

      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-50">
            <md-field :class="getValidationClass('nome')">
              <label :for="`nome${_uid}`">Nome</label>
              <md-input
                :id="`nome${_uid}`"
                v-model="form.nome"
                name="nome"
                :readonly="readOnly"
              />
              <span v-if="!$v.form.nome.required" class="md-error"
                >Nome é obrigatório</span
              >
            </md-field>
          </div>

          <div class="md-layout-item md-size-50">
            <md-field :class="getValidationClass('descricao')">
              <label :for="`descricao${_uid}`">Descrição</label>
              <md-input
                :id="`descricao${_uid}`"
                v-model="form.descricao"
                name="descricao"
                :readonly="readOnly"
              />
            </md-field>
          </div>

          <div v-if="readOnly" class="md-layout-item md-size-50">
            <md-field>
              <label :for="`readOnlyTimeZone${_uid}`">Fuso horário</label>
              <md-input
                :id="`readOnlyTimeZone${_uid}`"
                v-model="form.timeZone"
                name="readOnlyTimeZone"
                :readonly="readOnly"
              />
            </md-field>
          </div>

          <div v-if="!readOnly" class="md-layout-item md-size-30">
            <md-autocomplete v-model="form.timeZone" :md-options="timezones">
              <label>Fuso horário</label>
            </md-autocomplete>
            <span v-if="!$v.form.timezones" class="md-error" style="color: red"
              >Fuso horário inválido</span
            >
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import http from '../../utils/http'

const mustBeValidTimeZone = (list) => {
  return (value) => {
    return list.indexOf(value.timeZone) >= 0
  }
}

export default {
  name: 'LocalCampos',
  mixins: [validationMixin],
  props: ['nome', 'descricao', 'readOnly', 'timeZone'],
  data() {
    return {
      form: {
        nome: '',
        descricao: '',
        timeZone: 'America/Cuiaba',
      },
      timezones: [],
    }
  },
  validations() {
    return {
      form: {
        nome: { required },
        timezones: mustBeValidTimeZone(this.timezones),
      },
    }
  },
  beforeMount() {
    http.get('local/timezones').then((e) => {
      this.timezones = e.timezones.map((tz) => tz.id)
    })
  },
  mounted() {
    this.form.nome = this.nome
    this.form.descricao = this.descricao
    this.form.timeZone = this.timeZone || 'America/Cuiaba'
  },
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
    setData(data) {
      this.form = {
        ...this.form,
        ...data,
      }
    },
    returnData() {
      this.$v.$touch()

      return {
        data: { ...this.form },
        validation: !this.$v.$invalid,
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
